import axios from 'axios';
import env from '../Utils/env';
import localStorage from "redux-persist/lib/storage";


// Crée une instance Axios
const api = axios.create({
  baseURL: env.baseURL, 
});

// Intercepteur pour ajouter le token d'authentification
api.interceptors.request.use(async (config) => {
  const token = await localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


// Fonction pour récupérer toutes les catégories
export const getProductCategory = async () => {
    
  return api.get('/all-category');
};


// Fonction pour créer une catégorie
export const createCategory = async (CategoryData) => {
    
  return await api.post('/create-category', CategoryData);
};


export const deleteProductCategory = async (id) => {
  return api.delete(`/delete-category/${id}`)
};

export const updateCategory = async (data) => {
  return await api.put(`/update-category`, data);
};


// Fonction pour créer une catégorie
export const createUnity = async (UnityData) => {
    
  return await api.post('/create-unity', UnityData);
};

// Fonction pour récupérer toutes les unitées
export const getProductUnity = async () => {
    
  return api.get('/all-unities');

};

export const updateUnity = async (data) => {
  return await api.put(`/update-unity`, data);
};

export const deleteProductUnity = async (id) => {
  return api.delete(`/delete-unity/${id}`)
};


// Fonction pour créer un product
export const createProduct = async (productData) => {
    
  return await api.post('/create-product', productData);
};

// Récupérer tous les produits 
export const getProducts = async () => {
    
  return api.get('/all-products');

};

export const getProductLowStockAndOutofStock = async () => {
    
  return api.get('/all-products-low-stock-and-out-of-stock');

};


export const deleteProduct = async (id) => {
  return api.delete(`/delete-product/${id}`)
};

export const updatedProduct = async (data) => {
  return await api.put(`/update-product`, data);
};


// Fonction pour créer un un mouvement de produit
export const createStockMove = async (stockMovetData) => {
    
  return await api.post('/stock-moves', stockMovetData);
};

export const getStockMove = async () => {
    
  return await api.get('/stock-moves');
};

